export default "__VITE_ASSET__GAk7c8aD__"